// extracted by mini-css-extract-plugin
export default {"item":"Tags-module__item___Ob_2i","text":"Tags-module__text___WibFp","icon":"Tags-module__icon___Kplzo"};